var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div wb-payment-redirect>\n<h2>Redirecting to payment...</h2>\n</div>";
var id1="templates/public-booking/steps/payment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/templates/public-booking/steps/payment.html
// module id = 1278
// module chunks = 0